<template>
    <FKBreadCrumb :page="$t('page.surveys')">
    </FKBreadCrumb>
    <SurveyList/>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import SurveyList from "@/components/FK/Surveys/Admin/SurveyList.vue";
import { Survey } from "@/utils/models/survey.model";

export default defineComponent({
    name: "SurveyPage",
    components: {
        FKBreadCrumb,
        SurveyList
    },
    data() {
        return {
            survey: this.$route.meta.surveys as Survey[],
        }
    },
});
</script>